import { Box, Heading, Spacer } from '@homebotapp/hb-react-component-catalog'
import { Sidebar } from '../Sidebar/Sidebar'
import { SidebarGroup } from '../Sidebar/SidebarGroup'
import { defineMessages, useIntl } from 'react-intl'
import { SidebarItem } from '../Sidebar/SidebarItem'
import { NavigationShortcutDatum } from '../../../types/navigation'
import { GlobalTrackingEventLocation } from '../../../constants/tracking'
import { selectNativeAccessFeature } from '../../../store/selectors/customerProfile'
import { useSelector } from 'react-redux'
import { RootState } from '../../../types/rootState'
import { SidebarMobileAppAd } from './SidebarMobileAppAd'
import { SidebarAd } from './SidebarAd'
import { useAppSelector } from '../../../store/hooks'

const MSG = defineMessages({
  jumpTo: {
    id: 'MobileShortcutsDrawer.shortcutsDrawerContent.jumpTo',
    defaultMessage: 'Jump to'
  },
  quickActions: {
    id: 'MobileShortcutsDrawer.shortcutsDrawerContent.quickActions',
    defaultMessage: 'Quick Actions'
  }
})

type ClientNavigationSidebarProps = {
  heading: string
  jumpTo: NavigationShortcutDatum[]
  quickActions: NavigationShortcutDatum[]
}

export const ClientNavigationSidebar = ({ jumpTo, quickActions, heading }: ClientNavigationSidebarProps) => {
  const intl = useIntl()
  const hasNativeAccess = useSelector<RootState, boolean>(selectNativeAccessFeature)
  const hasSearchAccess = useAppSelector(state => state.customerProfile.data?.homebotListingsFeature)

  return (
    <Sidebar>
      <Heading as='h2' size='sm' px='3' mb='6' textAlign='left'>
        {heading}
      </Heading>
      <SidebarGroup title={intl.formatMessage(MSG.jumpTo)}>
        {jumpTo.map(option => (
          <SidebarItem key={option.name} option={option} mb='1' />
        ))}
      </SidebarGroup>
      <Spacer />
      <Box as='hr' borderBottomWidth='1px' mx='-2' mt='4' mb='0' />
      <SidebarGroup title={intl.formatMessage(MSG.quickActions)} paddingTop='3'>
        {quickActions.map(quickAction => (
          <SidebarItem key={quickAction.name} option={quickAction} mb='1' />
        ))}
      </SidebarGroup>
      {hasSearchAccess && (
        <SidebarAd
          marginTop='3'
          tracking={{
            guid: '5SsFGfecrBaVWCKwmtMaEU',
            ui_context: GlobalTrackingEventLocation.GLOBAL_SIDEBAR_GALLERIES_AD
          }}
        />
      )}
      {!hasSearchAccess && hasNativeAccess && (
        <SidebarMobileAppAd
          marginTop='3'
          tracking={{
            guid: 'mNa4wT1Vp65XfqhPVKehzk',
            ui_context: GlobalTrackingEventLocation.GLOBAL_SIDEBAR_NATIVE_APP_AD
          }}
        />
      )}
    </Sidebar>
  )
}
